import {ReactEventHandler, useCallback} from 'react';

import {mockIconURL} from '@web-catalog/const';

export const useOnImageError = () =>
  useCallback<ReactEventHandler<HTMLImageElement>>(({currentTarget}) => {
    currentTarget.src = mockIconURL;
  }, []);
